import { Component } from '@angular/core';
import { User } from '../../models/models';
import { UserAuthProvider } from '../../modules/mrk-user-auth/user-auth';
import { PopoverController, AlertController } from 'ionic-angular';
import { FlexMenuComponent } from '../flex-menu/flex-menu';

@Component({
  selector: 'app-user-header',
  templateUrl: 'header.html'
})
export class UserHeaderComponent {

  currentUser: User = {}
  userRole: string

  constructor(
    public userAuth: UserAuthProvider<User>,
    private popoverCtrl: PopoverController,
    private alertCtrl: AlertController) {
    console.log('HeaderComponent constructed');
    this.userAuth.userState.subscribe(
      userState => {
        this.currentUser = userState.user || {}
        this.userRole = null
      }
    )
  }

  userMenu(ev) {
    this.popoverCtrl.create(FlexMenuComponent, {
      user: this.currentUser ? {
        name: this.currentUser.firstname + " " + this.currentUser.surname,
        email: this.currentUser.email,
        avatar: this.currentUser.image,
        role: this.userRole
      } : {},
      options: [
        {
          icon: "log-out",
          name: "Esci",
          handler: () => {

            this.logout()
          }
        },
      ],
      theme: "#ff0033"
    }).present({ ev: ev })
  }


  logout() {
    this.alertCtrl.create({
      title: "Logout",
      message: "Vuoi effettuare il logout?",
      buttons: [
        {
          text: 'Annulla',
          handler: () => { }
        },
        {
          text: 'Logout',
          handler: () => {
            this.userAuth.logout().subscribe()
          }
        },
      ]
    }).present()
  }
}



// WEBPACK FOOTER //
// ./src/components/header/header.ts